import api from "@/app/api";
import { useApiCall } from "@/app/api/apiCall";
import { SubmitButton } from "@/app/components/SubmitButton";
import { Unauth } from "@/app/components/Unauth";
import { useStandardToast } from "@/app/hooks/useStandardToast";
import { Form, FormLayout } from "@saas-ui/react";
import { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router";

interface ResetPasswordPayload {
  password: string;
  token: string;
}

interface ResetPasswordForm {
  password: string;
}

export default function ResetPassword() {
  const [isResettingPassword, setIsResettingPassword] =
    useState<boolean>(false);
  const handle = useApiCall();
  const navigate = useNavigate();
  const toast = useStandardToast();
  const [searchParams] = useSearchParams();
  console.log(searchParams.get("token"));

  const onSubmit = async (payload: ResetPasswordForm) => {
    setIsResettingPassword(true);
    await handle(
      () =>
        api.resetPassword({
          ...payload,
          token: searchParams.get("token")!,
        }),
      () => {
        navigate("/login");
        toast({
          title: "Password reset successful",
          status: "success",
        });
      },
      () => setIsResettingPassword(false)
    );
  };

  if (!searchParams.get("token")) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Unauth
      form={
        <Form
          onSubmit={onSubmit}
          defaultValues={{
            password: undefined,
          }}
        >
          {({ Field }) => (
            <FormLayout>
              <Field
                name="password"
                label="Enter your new password"
                disabled={isResettingPassword}
                type="password"
                rules={{
                  required: "Password is required.",
                }}
              />
              <SubmitButton isDisabled={isResettingPassword}>
                Change password
              </SubmitButton>
            </FormLayout>
          )}
        </Form>
      }
      footer={null}
    />
  );
}
